/* CFAT: local PDF downloads. No customer information leaves the browser. */
(() => {
  if (window.CFATKitDownloads) return;
  const clean = value => String(value ?? '').normalize('NFKD').replace(/[\u2013\u2014]/g, '-').replace(/\u00d7/g, 'x').replace(/[\u2018\u2019]/g, "'").replace(/[\u201c\u201d]/g, '"').replace(/[^\x20-\x7E]/g, '');
  const escapePDF = value => clean(value).replace(/\\/g, '\\\\').replace(/\(/g, '\\(').replace(/\)/g, '\\)');
  function makePDF(data, kit) {
    const objects = [null, '<< /Type /Catalog /Pages 2 0 R >>', null, '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>', '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold >>'];
    let stream = '';
    const text = (x, y, value, size = 9, bold = false) => { stream += `BT /${bold ? 'F2' : 'F1'} ${size} Tf ${x} ${y} Td (${escapePDF(value)}) Tj ET\n`; };
    const line = (x, y, endX, endY) => { stream += `${x} ${y} m ${endX} ${endY} l S\n`; };
    const wrap = (value, max = 100) => {
      const lines = []; let current = '';
      for (const word of clean(value).split(' ')) {
        if ((current + word).length > max) { lines.push(current.trim()); current = ''; }
        current += word + ' ';
      }
      if (current.trim()) lines.push(current.trim());
      return lines;
    };
    stream += '0.10 0.11 0.13 rg\n';
    text(38, 756, 'CANADIAN FIRST-AID TRAINING', 10, true);
    stream += '0.85 0.025 0.13 RG\n1.5 w\n'; line(38, 746, 574, 746);
    text(38, 723, 'FIRST AID KIT INSPECTION CHECKLIST', 16, true);
    text(38, 703, kit.title, 14, true);
    text(38, 686, 'Supplier-listed CSA Z1220-17 range | Contents reviewed ' + data.reviewed, 8);
    text(38, 664, 'Site / kit location: ___________________________________________________________', 9);
    text(38, 646, 'Inspected by: __________________________     Date: __________________________', 9);
    text(38, 630, 'Count usable, unexpired supplies with intact applicable packaging. Check the exact kit model.', 8);
    stream += '0.12 0.13 0.15 rg\n38 599 536 23 re f\n1 1 1 rg\n';
    text(44, 607, 'SUPPLY', 8, true); text(307, 607, 'LISTED', 8, true); text(371, 607, 'USABLE', 8, true); text(428, 607, 'REPLACE', 8, true); text(490, 607, 'EXPIRY / NOTES', 7, true);
    let y = 599;
    for (let n = 0; n < kit.rows.length; n++) {
      const [id, quantity] = kit.rows[n], item = data.items[id];
      if (n % 2 === 0) stream += `0.96 0.97 0.98 rg\n38 ${y - 16.5} 536 16.5 re f\n`;
      stream += '0.12 0.13 0.15 rg\n';
      text(44, y - 11, item[0], 7.5); text(307, y - 11, quantity + ' ' + item[1], 7.2);
      stream += '0.82 0.84 0.87 RG\n0.25 w\n'; line(38, y - 16.5, 574, y - 16.5);
      y -= 16.5;
    }
    for (const x of [300, 365, 424, 485]) line(x, 599, x, y);
    stream += '0.12 0.13 0.15 rg\n'; y -= 16;
    if (kit.note) for (const row of wrap(kit.note, 110)) { text(38, y, row, 7.5); y -= 11; }
    if (y > 155) {
      text(38, y, 'Additional supplies / replenishment notes', 9, true);
      for (let rule = y - 18; rule > 125; rule -= 24) line(38, rule, 574, rule);
    }
    text(38, 95, 'Follow-up / restock action: __________________________________________________________', 8.5);
    text(38, 68, 'Inspection aid only: not the official CSA standard, a compliance certificate or dosing guidance.', 8);
    text(38, 55, 'Confirm your kit contents and applicable workplace requirements. CFAT: canadian-training.ca', 8);
    text(38, 41, 'Source: ' + kit.source, 7);
    objects.push(`<< /Length ${stream.length} >>\nstream\n${stream}endstream`);
    objects.push('<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] /Resources << /Font << /F1 3 0 R /F2 4 0 R >> >> /Contents 5 0 R >>');
    objects[2] = '<< /Type /Pages /Kids [6 0 R] /Count 1 >>';
    let output = '%PDF-1.4\n'; const offsets = [0];
    for (let i = 1; i < objects.length; i++) { offsets[i] = output.length; output += `${i} 0 obj\n${objects[i]}\nendobj\n`; }
    const xref = output.length; output += `xref\n0 ${objects.length}\n0000000000 65535 f \n`;
    for (let i = 1; i < objects.length; i++) output += String(offsets[i]).padStart(10, '0') + ' 00000 n \n';
    output += `trailer\n<< /Size ${objects.length} /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF`;
    return new Blob([output], { type: 'application/pdf' });
  }
  function init(root) {
    if (root.dataset.downloadsReady) return;
    const dataNode = root.querySelector('[data-cfat-pdf-data]');
    if (!dataNode) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); if (!Array.isArray(data.kits)) return; }
    catch (error) { return; }
    root.dataset.downloadsReady = 'true';
    const select = root.querySelector('[data-cfat-kit-choice]');
    const download = root.querySelector('[data-cfat-pdf-button]');
    const status = root.querySelector('[data-cfat-pdf-status]');
    const online = root.querySelector('[data-cfat-online-checklist]');
    function selectedKey() { return select ? select.value : root.dataset.kitKey; }
    function updateLink() {
      if (online) {
        const url = new URL(online.href, location.href); url.searchParams.set('kit', selectedKey()); online.href = url.href;
      }
    }
    if (select) select.addEventListener('change', () => { updateLink(); if (status) status.textContent = ''; });
    if (download) download.addEventListener('click', () => {
      try {
        const kit = data.kits.find(item => item.key === selectedKey());
        if (!kit) throw new Error('Checklist not found');
        const blobURL = URL.createObjectURL(makePDF(data, kit));
        const link = document.createElement('a'); link.href = blobURL; link.download = 'CFAT-' + kit.key + '-inspection-checklist.pdf';
        document.body.append(link); link.click(); link.remove();
        setTimeout(() => URL.revokeObjectURL(blobURL), 60000);
        if (status) status.textContent = 'Your ' + kit.title + ' PDF is ready. Check your downloads or PDF viewer.';
      } catch (error) { if (status) status.textContent = 'Please use Open checklist online below to view or save your checklist.'; }
    });
    updateLink();
  }
  function scan() { document.querySelectorAll('[data-cfat-downloads]').forEach(init); }
  window.CFATKitDownloads = { makePDF, scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
